import { put, takeLatest } from 'redux-saga/effects';
import { ManageStateLicense } from '../../reducers/r_index';
import { MessageType, Message } from '../../utils/variables';

import authService from './../../components/api-authorization/AuthorizeService';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk, codiceUtente } }) {
    try {
        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/UnblockLicense/' + pk + '/' + codiceUtente, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const responseResult = yield response.text();


        if (responseResult === Message.Unblocked) {
            yield put(ManageStateLicense.creators.unblockLicenseSuccess({ isUnblocked: responseResult }));
        }
        else if (responseResult === Message.NotUnblocked) {
            yield put(ManageStateLicense.creators.unblockLicenseFailed("Impossibile sbloccare la licenza selezionata."));
        }
        else if (responseResult.substring(0, 5) === MessageType.Error) {
            //se il messaggio è un errore, rimuovo [ERR] all'inizio
            yield put(ManageStateLicense.creators.unblockLicenseFailed(responseResult.substring(5)));
        }
        else yield put(ManageStateLicense.creators.unblockLicenseFailed(responseResult));

    } catch (e) {
        yield put(ManageStateLicense.creators.unblockLicenseFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(ManageStateLicense.types.UNBLOCK_LICENSE_REQUEST, runAction);
}